// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2kCkH","content":"styles_content__1aDSh","checkbox":"styles_checkbox__1UYar","checkboxLabel":"styles_checkboxLabel__2-X7L"};